import { css } from 'styled-components';
import { accent0, gray1, gray9 } from '../../globals/colors';
import { fontSize } from '../../globals/fontSize';
import { breakpoints, mobileMixin, responsivePropertyMixin } from '../../styles/mixins';

export const labeledCheckboxCss = css`
    ${responsivePropertyMixin(breakpoints, [
        ['font-size', ...Object.values(fontSize.xsmall)]
    ])}
`;

export const addAnotherCheckboxCss = css`
    ${responsivePropertyMixin(breakpoints, [
        ['font-size', ...Object.values(fontSize.xsmall)]
    ])};
    height: 64px;
    width: 64px;
    padding-bottom: 1rem;

    & > label {
        height: 128px !important;
        width: 128px !important;
        min-height: 128px !important;
        min-width: 128px !important;

        & > div {
            height: 32px !important;
            width: 32px !important;

            & svg {
            --fa-primary-color: ${gray9};
            --fa-secondary-color: ${accent0};
            --fa-secondary-opacity: 4.0; //Offsets FA Icon opacity changes
            height: 32px !important;
            width: 32px !important;
        }
        };

        & > span {
            font-size: 12px;
        };
    };
`;

export const rootCss = css`
    background: ${gray1};
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
`;

export const nextContainerCss = css`
    justify-content: flex-end;
`;

export const logoCss = css`
    ${responsivePropertyMixin(breakpoints, [
        ['height', ...Object.values(fontSize.large)]
    ])}
`;

export const responsivePadding = ['2rem', '3rem', '4rem'];
export const headerFooterMixin = css`
    flex-shrink: 0;
    ${responsivePropertyMixin(breakpoints, [
        ['padding', ...responsivePadding],
        ['height', '11.5rem', '14.5rem', '18rem'],
    ])}
`;

export const mainCss = css`
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${responsivePropertyMixin(breakpoints, [
        ['padding', '0 2rem', '0 5%', '0 10%']
    ])}
`;

/* eslint-disable indent */
export const footerCss = css`
    padding: 16px;

    ${mobileMixin(css`
        padding: 2rem;
    `)}
`;
/* eslint-enable indent */

export const progressCss = css`
    ${mobileMixin(css`
        display: none;
    `, 900)}
`;
